import { render, staticRenderFns } from "./MenuName.vue?vue&type=template&id=c41b9880&"
import script from "./MenuName.vue?vue&type=script&lang=js&"
export * from "./MenuName.vue?vue&type=script&lang=js&"
import style0 from "./MenuName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports